import React from "react";
import Text from "./Text";
import { BUTTON_BASE_CLASSES, getButtonStateClasses } from "./buttonStyles";

interface VirtualKeyboardActionButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  children: React.ReactNode;
  isSelected?: boolean; // 入力モード切替で選択中のもの
}

const VirtualKeyboardActionButton: React.FC<VirtualKeyboardActionButtonProps> = ({
  children,
  className = "",
  isSelected = false,
  ...rest
}) => {
  return (
    <button
      type="button"
      className={`flex h-16 min-w-12 items-center justify-center whitespace-nowrap px-4 ${BUTTON_BASE_CLASSES} ${getButtonStateClasses(isSelected, false)} ${className}`}
      aria-pressed={isSelected || undefined}
      {...rest}
    >
      <Text as="span" variant="body/l" weight="bold">
        {children}
      </Text>
    </button>
  );
};

export default VirtualKeyboardActionButton;
